import { useQuery } from '@tanstack/react-query';

import TQConnectAPI from '../../../api/TQConnectAPI';
import { useAppSelector } from '../../../shared/hooks';
import { QUERY_KEYS } from '../../../shared/queryKeys';
import { ITQConnectConfigResult } from '../../../types/tqConnectTypes';

/**
 * Custom hook to fetch TQ Connect configuration
 *
 * @returns useQuery result with TQ Connect config data
 */
export const useTQConnectConfig = () => {
  const {
    isLoggedIn,
    isTier4,
    hostMetadata: { isCommunityFeatureActive, isTQConnectFeatureActive },
  } = useAppSelector((state) => state.app);

  // TQ Connect is only available on Tier 4 hosts; the API returns 403 otherwise
  const shouldFetch = Boolean(
    isLoggedIn &&
    isTier4 &&
    isCommunityFeatureActive &&
    isTQConnectFeatureActive,
  );

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: QUERY_KEYS.TQ_CONNECT_CONFIG,
    queryFn: TQConnectAPI.getTQConnectConfig,
    enabled: shouldFetch,
    select: (resp) => resp.data.result as ITQConnectConfigResult,
    staleTime: Infinity, // Keep data cached forever, so that we don't need to fetch it again as it will be invalidated whenever tq connect config is updated through updateTQConnectConfig mutation
  });
};
